import { FC, useState } from 'react';
import { connect } from 'react-redux';
import i18next from 'i18next';

import { UserFormContainer } from '~src/modules/users/containers/userManagement.sc';
import ListAddButton from '~src/shared/lists/listAddButton/ListAddButton';
import { UserFormValues } from '~src/modules/users/interfaces';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import { addUser } from '~src/modules/users/actions/user.actions';
import { User, UserCore } from '~src/interfaces/user.interface';

import UserForm from './UserForm';

interface OwnProps {
  t: i18next.TFunction;
  updateAttributes: (
    userId: string,
    values: UserFormValues,
    initialValues: Partial<UserFormValues>,
  ) => Promise<void>;
  fetchUsers: () => Promise<void>;
}

interface DispatchProps {
  addUser: (values: UserCore) => ApiReduxResp<User>;
}

type Props = OwnProps & DispatchProps;

const AddUserForm: FC<Props> = props => {
  const [showForm, setShowForm] = useState(false);

  function toggleForm() {
    setShowForm(!showForm);
  }

  function addUserSubmit(values: UserFormValues, initialValues: Partial<UserFormValues>): Promise<void> {
    return props
      .addUser({
        firstname: values.firstname,
        lastname: values.lastname,
        email: values.email,
        username: values.username,
        deactivated: false,
      })
      .then(resp => {
        if (resp.error) {
          return resp.error.response.data;
        } else {
          props.updateAttributes(resp.response.data.uuid, values, initialValues).then(() => {
            setShowForm(false);
            props.fetchUsers();
          });
        }
      });
  }

  if (showForm) {
    return (
      <UserFormContainer>
        <UserForm onFrmSubmit={addUserSubmit} onCancel={toggleForm} form="add_user_form" />
      </UserFormContainer>
    );
  }

  return (
    <ListAddButton
      addFunc={toggleForm}
      buttonText={{
        key: 'x.users.add_new_user',
        txt: props.t('x.users.add_new_user'),
      }}
    />
  );
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  addUser: values => dispatch(addUser(values)),
});

const AddUserFormSuper = connect(null, mapDispatchToProps)(AddUserForm);
export default AddUserFormSuper;
